import { Layout } from 'antd';

interface PrivateLayoutContentProps {
  children?: any;
}

const PrivateLayoutContent = ({ children }: PrivateLayoutContentProps) => (
  <Layout.Content style={divContentStyle}>{children}</Layout.Content>
);

const divContentStyle = { margin: '0 16px' };

export default PrivateLayoutContent;
